import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("dds_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function deviceFingerprint() {
  const parts = [
    navigator.userAgent,
    navigator.language,
    `${window.screen.width}x${window.screen.height}`,
    window.screen.colorDepth,
    navigator.hardwareConcurrency || 0,
    new Date().getTimezoneOffset(),
  ];
  // Simple stable hash
  let h = 5381;
  const s = parts.join("|");
  for (let i = 0; i < s.length; i++) h = ((h << 5) + h) + s.charCodeAt(i);
  return "fp_" + Math.abs(h).toString(36);
}
